import { NftViewDesktopSkeleton } from './layouts/Desktop/Skeleton';
import { NftViewMobileSkeleton } from './layouts/Mobile/Skeleton';
import { isMobile } from 'utils';

export const NftViewSkeleton = () => {
  return isMobile() ? <NftViewMobileSkeleton /> : <NftViewDesktopSkeleton />;
};
